export default "__VITE_ASSET__h1eenr2g__"